export default __webpack_public_path__ + "static/media/profile_photo_square_small.d574da53.png";